export default {
  header: {
    projectName: '專案名稱',
    export: 'Export',
    debug: 'Debug',
    success: '成功',
    failed: '失敗',
    generating: '正在合成影片...',
    updateNameFailed: '更新專案名稱失敗',
    updateFailed: '更新失敗',
    menu: '選單',
    settings: '設定',
    shortcuts: '鍵盤快捷鍵',
    about: '關於',
    darkMode: '深色模式',
    lightMode: '淺色模式',
    settingsComingSoon: '設定功能即將推出',
    shortcutsComingSoon: '鍵盤快捷鍵功能即將推出',
    aboutComingSoon: '關於資訊即將推出',
    canvas: '畫布',
    view: '顯示',
    general: '一般',
    language: '語言'
  },
  menu: {
    media: '媒體庫',
    text: '文字'
  },
  loading: {
    core: '核心載入中...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: '公開測試版',
    betaDisclaimer: '測試版本不保證資料保存',
    newProject: '新建專案',
    backupFolder: '備份文件夾',
    documentation: '文檔',
    recentProjects: '最近專案',
    viewAll: '查看全部 ({count})',
    noProjects: '暫無專案。建立您的第一個專案開始吧！',
    login: '登入',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: '部落格',
    projectCreated: '專案已建立',
    projectCreatedDesc: '新專案建立成功',
    projectDeleted: '專案已刪除',
    projectDeletedDesc: '專案刪除成功',
    deleteConfirmation: '您確定要刪除此專案嗎？此操作無法撤銷。',
    migrationFailed: '遷移失敗',
    migrationFailedDesc: '無法從 localStorage 遷移數據',
    loadFailed: '載入失敗',
    loadFailedDesc: '無法載入專案列表',
    creationFailed: '建立失敗',
    creationFailedDesc: '無法建立新專案',
    deletionFailed: '刪除失敗',
    deletionFailedDesc: '無法刪除專案'
  },
  timeline: {
    autoSaveFailed: '自動儲存失敗',
    autoSaveFailedDesc: '無法自動儲存專案',
    loadFailed: '載入失敗',
    loadFailedDesc: '無法載入專案。正在重新導向到首頁...',
    mainTrack: '主軌道',
    undo: 'Undo',
    redo: 'Redo',
    split: '分割',
    delete: '刪除'
  },
  attributes: {
    properties: '屬性',
    position: '位置',
    scale: '縮放',
    animation: '動畫',
    basic: '基礎',
    mute: '靜音',
    text: '文字',
    fontSize: '字號',
    content: '內容',
    fontFamily: '字體',
    direction: '文字方向',
    color: '顏色',
    stroke: '描邊',
    background: '背景',
    video: '影片',
    rotate: '旋轉',
    backgroundColor: '背景顏色',
    opacity: '不透明度',
    blend: '混合',
    filter: '濾鏡',
    effect: '特效',
    transition: '轉場',
    speed: '速度',
    volume: '音量'
  },
  router: {
    timeline: '影片編輯器',
    preview: '預覽',
    storyboard: 'Storyboard - AI 影片代理'
  },
  placeholder: {
    text: '請輸入文字內容',
    input: '請輸入'
  },
  error: {
    parseAudio: '分析音檔失敗',
    parseImage: '分析圖片失敗',
    parseVideo: '分析影片失敗',
    noProject: '請先建立或開啟專案',
    invalidFileType: '不支援的檔案類型'
  },
  media: {
    video: '影片',
    image: '圖片',
    audio: '音樂',
    dropToUpload: '拖曳檔案至此上傳'
  },
  common: {
    defaultText: '文本內容',
    delete: '刪除'
  }
};
